import { v4 as uuidv4 } from 'uuid';
var CartProduct = Backbone.Model.extend({
    defaults: {
        'cart_id' : null,
        'post_id': 0,
        'name' : '',
        'link' : '',
        'image': '',
        'sku' : '',
        'parent_sku' : '',
        'settings' : {},
        'settings_labels' : {},
        'quantity': 1,
        'variation': {},
        'product_categories' : [],
        'product_family': '',
        'swatch_exclusions': [],
		'editing' : false
    },
    initialize: function(){
        // maybe set a unique id when creating if not already present

        if ( _.isNull( this.get( 'cart_id' ) ) ) {
            var uniq = uuidv4();
            this.set( { 'cart_id' : uniq } );
        }
    }
});
export {CartProduct};